/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCUpIcon16Light = forwardRef('ArrowCUpIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M3.149 10.356a.5.5 0 0 1-.005-.707l3.793-3.843A1.5 1.5 0 0 1 9.065 5.8l3.789 3.789a.5.5 0 0 1-.708.707L8.358 6.506a.5.5 0 0 0-.71.003L3.857 10.35a.5.5 0 0 1-.707.005Z" })));
});
